import React from 'react';
import { COLORS, TABS } from '../utils/constants.js';

export default function TabNav({ activeTab, setActiveTab }) {
  return (
    <nav
      style={{
        display: 'flex',
        gap: 2,
        padding: '0 24px',
        borderBottom: `1px solid ${COLORS.border}`,
        background: COLORS.surface,
        overflowX: 'auto',
      }}
    >
      {TABS.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          style={{
            padding: '12px 18px',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 13,
            fontWeight: activeTab === tab.id ? 600 : 400,
            color: activeTab === tab.id ? COLORS.accent : COLORS.textMuted,
            borderBottom:
              activeTab === tab.id
                ? `2px solid ${COLORS.accent}`
                : '2px solid transparent',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          <span style={{ marginRight: 6 }}>{tab.icon}</span>
          {tab.label}
        </button>
      ))}
    </nav>
  );
}
